<header class="modal-header" mat-dialog-title>
  <div class="flex justify-between">
    <h2 *ngIf="!editFlag" class="modal-headline">Aspect Ratio file Upload</h2>
    <h2 *ngIf="editFlag" class="modal-headline">Edit file format metadata</h2>

    <button [disabled]="uploadInProgress" type="button" class="button-close" mat-icon-button (click)="cancelUpload()">
      <mat-icon class="material-icons-outlined" aria-hidden="true">close</mat-icon>
      <span class="sr-only" i18n>Close</span>
    </button>
  </div>
</header>

<mat-dialog-content class="mat-typography modal-main min-h-[360px]">
  <div *ngIf="!editFlag" class="upload-section">
    <sp-file-drag-n-drop (uploadedFiles)="selectedFiles($event)" class="w-full p-3 m-auto"></sp-file-drag-n-drop>
    <sp-file-list
      *ngIf="files.length"
      class="w-full p-3 m-auto"
      [files]="files"
      [uploadInProgress]="uploadInProgress"
      [progress]="progress"
      [currentUploadFileName]="currentUploadFileName"
      (filesList)="updatedFilesList($event)"
    ></sp-file-list>
  </div>
  <form [formGroup]="form" class="w-full" (ngSubmit)="onSubmit()">
    <div class="flex flex-col lg:flex-row gap-6 w-3/4">
      <div class="flex flex-col w-2/5">
        <span class="w-2/5 field-label" i18n>Medium</span>
        <sp-mat-select-search formControlName="assetMedium" [dataSource]="assetMediumOptions" [config]="{ search: true }" [attrDataTestId]="'upload-variants_medium'"></sp-mat-select-search>
      </div>
      <div class="flex flex-col w-2/5" *ngIf="this.data.assetType === AssetTypeEnum.Video">
        <span class="w-2/5 field-label" i18n>Audio file</span>
        <sp-mat-select-search formControlName="audioFile" [dataSource]="audioTypeOptions" [config]="{ search: true }" [attrDataTestId]="'upload-variants_audio-file'"></sp-mat-select-search>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button type="button" *ngIf="!editFlag" [disabled]="form.invalid || uploadInProgress || files.length <= 0" (click)="onSubmit()" class="button-primary ml-auto" mat-flat-button>
    <ng-container i18n>Upload</ng-container>
    <mat-icon class="material-icons-outlined ml-2">cloud_upload</mat-icon>
  </button>
  <button type="button" *ngIf="editFlag" [disabled]="(editFlag && form.pristine) || form.invalid || uploadInProgress" (click)="onSubmit()" class="button-primary ml-auto" mat-flat-button>
    <ng-container i18n>Update</ng-container>
  </button>
</mat-dialog-actions>
